var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSailing = function SvgSailing(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7451 418.29C69.7851 418.29 69.7851 454.29 105.825 454.29C141.865 454.29 141.865 418.29 177.905 418.29C213.945 418.29 213.945 454.29 249.985 454.29C286.025 454.29 286.025 418.29 322.075 418.29C358.125 418.29 358.115 454.29 394.165 454.29C430.215 454.29 430.205 418.29 466.255 418.29",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.005 387.04L407.405 339.55C404.655 347.71 399.195 360.63 388.255 373.64C377.185 386.8 365.235 394.44 357.615 398.53",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.705 362.96V45.71C294.265 77.83 324.045 119.2 351.495 170.27C374.285 212.67 390.475 252.47 402.135 286.99C397.545 281.47 363.065 242.5 315.885 246.1C298.715 247.41 287.055 254.91 287.055 254.91C276.145 261.93 270.365 271.22 267.715 276.26",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.615 109.61C199.015 138.26 175.365 176.49 155.015 224.27C135.255 270.68 124.175 313.04 117.735 347.06C123.385 338.01 135.895 325.33 152.885 310.99C172.585 294.35 196.555 280.52 213.585 291.72L219.605 109.62L219.615 109.61Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSailing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/sailing.svg";